import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import "./audio-view.css";
import CommentIcon from "../../assets/icons/comment-icon.svg";
import { setIsAudioTagActive, unsetIsAudioTagActive, unsetAudioTagClicked } from '../../actions/CommentAction'
import { getFormatTime } from '../../utils/formatVideoTime';

export class AudioView extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      currentPosition: "00:00"
    }
  }

  componentDidMount() {
    this.myRef.current.addEventListener("timeupdate", this.handleTimeUpdate);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.isDartOpen !== this.props.isDartOpen &&
      this.props.isDartOpen
    ) {
      this.pauseAudio();
    }

    if (
      prevProps.isVersionsShowCompareOpen !==
        this.props.isVersionsShowCompareOpen &&
      this.props.isVersionsShowCompareOpen
    ) {
      this.pauseAudio();
    }
  }

  handleTimeUpdate = () => {
    if (this.myRef && this.myRef.current) {
      const currentPosition = this.myRef.current.currentTime;
      this.setState({
        currentPosition: getFormatTime(currentPosition)
      })
    }
  };

  pauseAudio = () => {
    try {
      this.myRef.current.pause();
    } catch (error) {
      console.error(error);
    }
  };

  handleAudioTag = () => {
    const {
      isAudioTagActive,
      setIsAudioTagActive,
      unsetIsAudioTagActive,
      showCommentComponent,
      isShowComments
    } = this.props;

    const { currentPosition } = this.state;

    if (!isShowComments) {
      showCommentComponent();
      setIsAudioTagActive(currentPosition);
      this.pauseAudio();
    } else {
      if (isAudioTagActive) {
        unsetIsAudioTagActive();
        this.pauseAudio();
      } else {
        setIsAudioTagActive(currentPosition);
        this.pauseAudio();
      }
    }
  };

  render() {

    const { 
      item,
      autoPlay,
      isComment,
      timePickerEnabled = false,
      audioTagClicked
    } = this.props;
    const {currentPosition} = this.state;
    const isAutoplay = (autoPlay) ? true : false;
    if (audioTagClicked && audioTagClicked.isClicked) {
      if (this.myRef && this.myRef.current) {
        this.myRef.current.currentTime = audioTagClicked.time
        this.props.unsetAudioTagClicked()
      }
    }
    return (
      <div className='audio-view-wrapper'>
        <div style={{ textAlign: 'center', display: "flex", justifyContent: isComment ? "left" : "center", flexDirection: 'column'}}>
          {/* <audio controls controlsList="nodownload" ref={this.myRef} autoPlay={isAutoplay}>
            <source src={item.mediaQualityURL} type="audio/*" />
            Your browser does not support the audio element.
          </audio> */}
          <audio src={item.originalURL} type="audio/*" controls controlsList="nodownload" ref={this.myRef}  autoPlay={isAutoplay}>
            Your browser does not support the audio element.
          </audio>
        </div>
        {timePickerEnabled && <div 
          className='time-ind-wrapper'
          onClick={this.handleAudioTag}
        >
          <div className='time-ind-img-wrapper'>
            <img src={CommentIcon} alt="O" className='time-ind-img'/>
          </div>
          <p>{`Comentar ${currentPosition}`}</p>
        </div>}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let commentsAndversionAware = {};
  if (ownProps.canCommentsAndVersions) {
    commentsAndversionAware = {
      isDartOpen: state.comments.show,
      isVersionsShowCompareOpen: state.comments.versionsShowCompare
    };
  }

  return {
    ...commentsAndversionAware,
    audioTagClicked: state.comments.audioTagClicked,
  }

}

const mapDispatchToProps = {
  setIsAudioTagActive,
  unsetIsAudioTagActive,
  unsetAudioTagClicked
}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AudioView))
);
